import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        step: '=',
        formId: '=',
        setStep: '&',
        setSummary: '&',
        update: '&'
    },
    template: `
    <div class="loader02" ng-if="vm.importing">{{ 'question.Please wait' | translate }}</div>
    <div class="modal-body">
        <modals-question-import-steps step="vm.step"/>
        <div ng-if="vm.QuestionImportService.questionType === vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX" class="alert alert-notify">
            {{ "question.Points value of '-1' points will be assigned to all false answers automatically" | translate }}
        </div>
        <div ng-if="vm.headerRow">
                <h3>{{ 'question.Check the structure' | translate }}</h3>
                <table class="data01" datatable dt-options="vm.DATATABLES">
                    <thead>
                        <tr>
                            <th class="w1p nosort"><input type="checkbox" ng-model="vm.toggleAll" ng-change="vm.selectAll()"></th>
                            <th>{{ 'question.Column' | translate }}</th>
                            <th>{{ 'question.Samples from file' | translate }}</th>
                            <th>{{ 'question.Database field' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="header in vm.headerRow">
                            <td class="w1p"><input type="checkbox" ng-click="$event.stopPropagation();vm.toggleAll = false" ng-model="vm.form.useInImport[$index]"></td>
                            <td>{{ header }}</td>
                            <td>{{ vm.firstRow[$index] }}</td>
                            <td class="input">
                                <select class="form-control"
                                    ng-change="vm.toggleCheckBox($index, vm.form.field[$index])"
                                    ng-model="vm.form.field[$index]"
                                    ng-options="field.key as field.item for field in vm.QuestionImportService.getImportableFields()">
                                    <option></option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <ul class="actions01">
            <li class="primary"><button class="btn main" type="button" ng-click="vm.validateAndImport()">{{ 'general.Next' | translate }}</button></li>
            <li><button class="btn discrete" type="button" ng-click="vm.update()">{{ 'general.Cancel' | translate }}</button></li>
        </ul>
    </div>
    `
})
export default class {
    constructor ($translate, toastr, lodash, QuestionImportService, QuestionResource,
                 DATATABLES, QUESTIONS_FIELDS_OTHER_ENUM, QUESTIONS_TYPE_ENUM) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.QuestionImportService = QuestionImportService;
        this.QuestionResource = QuestionResource;
        this.DATATABLES = DATATABLES;
        this.QUESTIONS_FIELDS_OTHER_ENUM = QUESTIONS_FIELDS_OTHER_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
    }

    $onInit () {
        this.toggleAll = true;
        this.form = { useInImport: [], field: [] };
        this.headerRow = this.QuestionImportService.getParsedCsvFile()[0];
        this.firstRow = this.QuestionImportService.getParsedCsvFile()[1];
        this.selectAll();
        this.importing = false;
    }

    selectAll () {
        for (let i = 0; i <= this.firstRow.length - 1; i++) {
            this.form.useInImport[i] = !this.form.useInImport[i];
        }
    }

    validateAndImport () {
        let error = false;
        angular.forEach(this.form.useInImport, (value, key) => {
            if (value === true && !this.form.field[key] && !error) {
                this.toastr.error(this.$translate.instant('question.All used fields must have database field assigned'));
                error = true;
            }
        });

        const duplicates = this.form.field.filter(item => this.form.field.filter(item2 => item2 === item).length > 1)
            .filter(item => item !== this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.ANSWER &&
                item !== this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.ANSWER_FEEDBACK
            );

        if (duplicates.length > 0 && !error) {
            error = true;
            this.toastr.error(this.$translate.instant('question.Check for duplicated database fields. You can have only multiple tags and answers.'));
        }

        angular.forEach(this.QuestionImportService.getRequiredFields(), (value) => {
            if (!this.lodash.includes(this.form.field, value) && !error) {
                error = true;
                this.toastr.error(this.$translate.instant('question.Question must have external id, name, answer and correct answer'));
            }
        });

        if (!error) {
            this.form.formId = this.formId;
            this.QuestionImportService.organizeForm = this.form;
            this.importing = true;
            this.QuestionResource.import(null, this.QuestionImportService.getFormattedImportData()).$promise.then((response) => {
                this.importing = false;
                this.setSummary({ summary: response });
                if (response.failed === 0) {
                    this.setStep({ step: 4 });
                }
                else {
                    this.setSummary({ summary: response });
                    this.setStep({ step: 3 });
                }
            });
        }
    }

    toggleCheckBox (index, selectedField) {
        this.form.useInImport[index] = false;
        if (selectedField) {
            this.form.useInImport[index] = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/import/organize/index.js